import GoodsPriceRow, { GOODS_CODE } from '../GoodsPriceRow';

const PopupPAHAB010Tab1 = ({ closePopup, goodsMap }) => {
    return (
        <div className="ticket-pop ">
            <div className="ticket-pop__block">
                <div className="ticket__table">
                    <div className="ticket__grid ticket__grid--head">
                        <span>광고 상품 / 덴탈잡 이용권</span>
                        <span style={{ justifyContent: 'center' }}>
                            <img src=".././images/PAHAB010/popticket_dentalJob.png" alt="popticket_dentalJob" />
                        </span>
                        <span style={{ justifyContent: 'center' }}>
                            <img src=".././images/PAHAB010/popticket_dvmall.png" alt="popticket_dvmall" />
                        </span>
                        <span style={{ justifyContent: 'center' }}>
                            <img src=".././images/PAHAB010/popticket_dvmall_membership.png" alt="popticket_dvmall" />
                        </span>

                    </div>
                    <GoodsPriceRow goods={goodsMap[GOODS_CODE.BUSINESS_BANNER]} />
                    <GoodsPriceRow goods={goodsMap[GOODS_CODE.GRAND_BANNER]} />
                    <GoodsPriceRow goods={goodsMap[GOODS_CODE.GRAND_BANNER_FIXED]} />
                    {/* <div className="ticket__grid">
                        <span className="left d-block">
                            그랜드 배너
                            <br />
                            <small>+채용광고 디자인 서비스</small>
                        </span>
                        <span>-</span>
                        <span>
                            <b>400,000</b>원
                        </span>
                    </div> */}
                    <GoodsPriceRow goods={goodsMap[GOODS_CODE.PREMIUM_BANNER]} />
                    <GoodsPriceRow goods={goodsMap[GOODS_CODE.PREMIUM_BANNER_FIXED]} />
                    {/* <div className="ticket__grid">
                        <span className="left d-block">
                            프리미엄 배너
                            <br />
                            <small>+채용광고 디자인 서비스</small>
                        </span>
                        <span>-</span>
                        <span>
                            <b>360,000</b>원
                        </span>
                    </div> */}
                    <GoodsPriceRow goods={goodsMap[GOODS_CODE.COMPANY_BANNER]} />
                    <GoodsPriceRow goods={goodsMap[GOODS_CODE.HOT_RECRUIT_BANNER]} />
                    <GoodsPriceRow goods={goodsMap[GOODS_CODE.HOT_RECRUIT_BANNER_FIXED]} />
                </div>
                <img src=".././images/PAHAB010/popticket_footer.png" alt="popticket_footer" />
                <button className="byn__btn" onClick={closePopup}>
                    가격표 닫기
                </button>
            </div>
        </div>
    );
};
export default PopupPAHAB010Tab1;
